import { useOutletContext } from "react-router";

import Box from "ds/components/Box";
import { isScanRunInProgress } from "shared/Scan/access/useCanTriggerScan";

import { ScanResourcesOutletContext } from "../../types";
import styles from "./styles.module.css";
import ScanResourcesSummaryTile from "./Tile";

const ScanResourcesSummary = () => {
  const { run } = useOutletContext<ScanResourcesOutletContext>();
  const isScanInProgress = isScanRunInProgress(run?.state);

  if (!run?.resourceCount) {
    return null;
  }

  return (
    <Box direction="row" fullWidth surfaceColor="primary" className={styles.bar}>
      <ScanResourcesSummaryTile
        title="Total resources"
        value={run.resourceCount}
        infoTooltip="All resources this scan run discovered."
        loading={isScanInProgress}
        withDivider
      />
      <ScanResourcesSummaryTile
        title="Managed resources"
        value={run.resourceStats.managed}
        infoTooltip="Resources already managed by a Spacelift stack."
        loading={isScanInProgress}
        withDivider
      />
      <ScanResourcesSummaryTile
        title="Unmanaged resources"
        value={run.resourceStats.unmanaged}
        valueColor="warning"
        infoTooltip="Resources not managed by a Spacelift stack."
        loading={isScanInProgress}
      />
    </Box>
  );
};

export default ScanResourcesSummary;
